import React, { useEffect } from 'react'
import { useState } from 'react'
import ReactPlaceholder from 'react-placeholder/lib'
import { useSelector } from 'react-redux'
import { FormCustom, TextArea } from '../../Components/Form/Form'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { SurfaceCard, EmptyState } from '../../Components/Ui'
import { toast } from 'react-toastify'

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
}

const IncidenceSolution = ({ idIncidence, onSubmit }) => {
    const store = useSelector(store => store)
    const [ready, setReady] = useState(false)
    const [row, setRow] = useState({
        p_id_incidence: idIncidence,
        p_description_comment: ''
    })
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [comments, setComments] = useState([])

    const handleSubmitComment = _ => {
        setLoadSubmit(true)
        Controllers.incidence.incidence_comment_insert(row).then(res => {
            Helpers.toast.construct({ ...res, toast })
            setRow({ ...row, p_description_comment: '' })
            setReady(false)
            setLoadSubmit(false)
            onSubmit()
        })
    }

    useEffect(() => {
        if (!ready) {
            Controllers.incidence.get_incidence_comment({
                p_id_incidence: idIncidence
            }).then(res => {
                setComments(res.data)
                setReady(true)
            })
        }
    }, [ready, idIncidence])

    return <>
        <div className="col-12 form-row" style={{ gap: 0 }}>
            <div className="col-12 col-md-4 mb-3">
                <SurfaceCard title="Tu comentario">
                    <div className="d-flex align-items-center mb-2" style={{ gap: 10 }}>
                        <img src={store.session.file_photo_user} alt="" style={{
                            borderRadius: '50px',
                            border: '1px solid #E5E7EB'
                        }} width="36" />
                        <span style={{ color: '#201030', fontWeight: 700, fontSize: '0.9rem' }}>
                            Escribe una alternativa de solución
                        </span>
                    </div>
                    <FormCustom viewSubmit={false} dataSubmit={row} onSubmit={handleSubmitComment}>
                        <TextArea text="Comentario" classNameParent="col-12 mt-2" rows="5" required value={row.p_description_comment} onChange={e => setRow({ ...row, p_description_comment: e.currentTarget.value })} />
                        <div className="col-12 mt-3">
                            <button type="submit" style={btnPrimary}>
                                {loadSubmit
                                    ? <i className="fa fa-circle-notch fa-spin" />
                                    : <><i className="fa fa-check" />Enviar</>}
                            </button>
                        </div>
                    </FormCustom>
                </SurfaceCard>
            </div>
            <div className="col-12 col-md-8">
                {comments.length === 0 ? (
                    <SurfaceCard>
                        <EmptyState
                            icon="fas fa-reply"
                            title="¡Sé el primero!"
                            text="Deja tu alternativa de solución."
                        />
                    </SurfaceCard>
                ) : (
                    <ReactPlaceholder className="mb-2" ready={ready} showLoadingAnimation rows={15}>
                        {React.Children.toArray(comments.map(c => {
                            return <SurfaceCard className="mb-3">
                                <section className="d-flex" style={{ gap: 12 }}>
                                    <div>
                                        <img src={Helpers.config.resourcesUrl({ url: c.file_photo_cust })} width="36" alt="" style={{
                                            borderRadius: 50,
                                            border: '1px solid #E5E7EB'
                                        }} />
                                    </div>
                                    <div className="d-flex flex-column">
                                        <h6 style={{ color: '#201030', fontWeight: 700, marginBottom: 2 }}>{c.full_name_cust}</h6>
                                        <p style={{ color: '#6B7280', fontSize: '0.8rem', marginBottom: 8 }}>{c.date_created}</p>
                                        <p style={{ margin: 0, color: '#2A2A2A' }}>{c.description_comment}</p>
                                    </div>
                                </section>
                            </SurfaceCard>
                        }))}
                    </ReactPlaceholder>
                )}
            </div>
        </div>
    </>
}

export default IncidenceSolution
